import type { RefObject } from 'react';
import { karaokeReveal } from '../../../util/animation/karaoke-reveal/karaoke-reveal';
import { fadeFromTo } from '../../../util/animation/fade/fade';

interface KaraokeRefs {
  elementRef?: RefObject<HTMLElement | null>;
  textRef?: RefObject<HTMLElement | null>;
}

export function karaokeLineReveal(timeline: gsap.core.Timeline, { textRef }: KaraokeRefs): void {
  if (textRef?.current) {
    timeline.add(karaokeReveal(textRef.current, { rightAlpha: 0.375 }));
  }
}

export function textParallax(timeline: gsap.core.Timeline, { textRef }: KaraokeRefs): void {
  if (!textRef) return;
  timeline.fromTo(
    textRef.current,
    {
      transform: 'translate3d(0, 25vh,0)',
    },
    {
      ease: 'none',
      transform: 'translate3d(0,-15vh,0)',
    },
  );
}

export function opacity(timeline: gsap.core.Timeline, { elementRef }: KaraokeRefs): void {
  if (elementRef?.current) {
    timeline.add(fadeFromTo(elementRef.current, { from: 0.1 }));
  }
}
